module.exports = __webpack_public_path__ + "img/lights_default.65fb6323.svg";